import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import { COMPANY } from "@/i18n/translations";

export const WhatsAppFloat = () => {
  const { t, dir } = useLang();
  const href = `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(
    "Hello Orion FM, I'd like a quote for my facility."
  )}`;

  const sideClass = dir === "rtl" ? "left-5" : "right-5";

  return (
    <a
      data-testid="whatsapp-float"
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp"
      className={`fixed bottom-5 ${sideClass} z-50 group`}
    >
      <span className="absolute inset-0 -m-1 rounded-full bg-green-500/30 animate-ping" />
      <span className="relative flex items-center gap-2 rounded-full bg-[#25D366] text-white shadow-2xl px-4 py-3 hover:bg-[#1ebe57] transition-colors">
        <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current" aria-hidden>
          <path d="M20.52 3.48A11.92 11.92 0 0 0 12.04 0C5.46 0 .12 5.34.12 11.92c0 2.1.55 4.15 1.6 5.96L0 24l6.27-1.65a11.9 11.9 0 0 0 5.77 1.47h.01c6.58 0 11.92-5.34 11.92-11.92 0-3.18-1.24-6.18-3.45-8.42zM12.05 21.4h-.01a9.9 9.9 0 0 1-5.04-1.38l-.36-.21-3.72.98 1-3.62-.24-.37a9.86 9.86 0 0 1-1.51-5.27c0-5.46 4.45-9.91 9.92-9.91 2.65 0 5.13 1.03 7 2.9a9.85 9.85 0 0 1 2.91 7.01c0 5.46-4.45 9.87-9.92 9.87zm5.45-7.4c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.49s1.07 2.89 1.22 3.09c.15.2 2.1 3.21 5.1 4.5.71.3 1.27.49 1.7.62.71.23 1.36.2 1.87.12.57-.08 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.13-.27-.2-.57-.35z" />
        </svg>
        <span className="hidden sm:inline text-sm font-semibold">{t("common.whatsapp")}</span>
      </span>
    </a>
  );
};
